import Vue from 'vue'
import VueRouter from 'vue-router'
import NaniungoLanding from '@/components/NaniungoLanding'
import Candidates from '@/components/Candidates'
import Representatives from '@/components/Representatives'
import Projects from '@/components/Projects'
import About from '@/components/About'
import Impressum from '@/components/Impressum'
import Datenschutz from '@/components/Datenschutz'
import Themen from '@/components/Themen'
import Karriere from '@/components/Karriere'
import Blog from '@/components/Blog'
import Article from '@/components/Article'
import Publications from '@/components/Publications'
import Vakanzen from '@/components/Vakanzen'
import Consent from '@/components/Consent'

Vue.use(VueRouter)

const router = new VueRouter({
  routes: [
    {
      path: '/',
      name: 'home',
      component: NaniungoLanding,
      meta: {
        title: 'naniungo® Deutschland GmbH | connecting business experts‎',
        metaTags: [
          {
            name: 'description',
            content: 'Startseite'
          },
          {
            property: 'og:description',
            content: 'Startseite'
          }
        ]
      }
    },
    {
      path: '/executives',
      name: 'candidates',
      component: Candidates,
      beforeEnter: (to, from, next) => {
        if (from.name === "home" || from.name === "projects" || from.name === "representatives" || from.name === "about" || from.name === "themen" || from.name === "naniungo" || from.name === "blog" || from.name === "vakanzen") {
          document.querySelector('.md-app-content').scrollIntoView();
          next();
        } 
        else {
          //pass
          next();
        }
      },
      meta: {
        title: 'executives',
        metaTags: [
          {
            name: 'description',
            content: 'Ihr Expertennetzwerk für Fach- und Führungskräfte'
          },
          {
            property: 'og:description',
            content: 'Ihr Expertennetzwerk für Fach- und Führungskräfte'
          }
        ]
      }
    },
    {
      path: '/representatives',
      name: 'representatives',
      component: Representatives,
      beforeEnter: (to, from, next) => {
        if (from.name === "home" || from.name === "projects" || from.name === "candidates" || from.name === "about" || from.name === "themen" || from.name === "blog" || from.name === "vakanzen") {
          document.querySelector('.md-app-content').scrollIntoView();
          next();
        } 
        else {
          //pass
          next();
        }
      },
      meta: {
        title: 'representatives',
        metaTags: [
          {
            name: 'description',
            content: 'Finden Sie exklusive Meinungsführer und Influencer für Ihr Unternehmen'
          },
          {
            property: 'og:description',
            content: 'Finden Sie exklusive Meinungsführer und Influencer für Ihr Unternehmen'
          }
        ]
      }
    },
    { 
      path: '/projects',
      name: 'projects',
      component: Projects,
      beforeEnter: (to, from, next) => {
        if (from.name === "home" || from.name === "candidates" || from.name === "representatives" || from.name === "about" || from.name === "themen" || from.name === "naniungo" || from.name === "impressum" || from.name === "vakanzen") {
          document.querySelector('.md-app-content').scrollIntoView();
          next();
        } 
        else {
          //pass
          next();
        }
      },
      meta: {
        title: 'projects',
        metaTags: [
          {
            name: 'description',
            content: 'Sie suchen einen Interim Manager/Freelancer für Ihre Projekte oder einer klassischen Vakanzüberbrückung?'
          },
          {
            property: 'og:description',
            content: 'Sie suchen einen Interim Manager/Freelancer für Ihre Projekte oder einer klassischen Vakanzüberbrückung?'
          }
        ]
      }
    },
    { 
      path: '/publications',
      name: 'publications',
      component: Publications,
      beforeEnter: (to, from, next) => {
        if (from.name === "home" || from.name === "candidates" || from.name === "representatives" || from.name === "about" || from.name === "themen" || from.name === "naniungo" || from.name === "impressum" || from.name === "blog" || from.name === "vakanzen") {
          document.querySelector('.md-app-content').scrollIntoView();
          next();
        } 
        else {
          //pass
          next();
        }
      },
      meta: {
        title: 'publications',
        metaTags: [
          {
            name: 'description',
            content: 'Ihr naniungo Stellenportal'
          },
          {
            property: 'og:description',
            content: 'Ihr naniungo Stellenportal'
          }
        ]
      }
    },
    { 
      path: '/about',
      name: 'about',
      component: About,
      beforeEnter: (to, from, next) => {
        if (from.name === "home" || from.name === "candidates" || from.name === "representatives" || from.name === "projects" || from.name === "themen" || from.name === "naniungo" || from.name === "vakanzen") {
          document.querySelector('.md-app-content').scrollIntoView();
          next();
        } 
        else {
          //pass
          next();
        }
      },
      meta: {
        title: 'Über Uns',
        metaTags: [
          {
            name: 'description',
            content: ' Erfahren Sie mehr über die naniungo Deutschland GmbH'
          },
          {
            property: 'og:description',
            content: ' Erfahren Sie mehr über die naniungo Deutschland GmbH'
          }
        ]
      }
    },
    { 
      path: '/impressum',
      name: 'impressum',
      component: Impressum,
      beforeEnter: (to, from, next) => {
        if (from.name === "home" || from.name === "candidates" || from.name === "representatives" || from.name === "projects" || from.name === "themen" || from.name === "naniungo" || from.name === "about" || from.name === "blog" || from.name === "karriere" || from.name === "vakanzen" || from.name === "datenschutz") {
          document.querySelector('.md-app-content').scrollIntoView();
          next();
        } 
        else {
          //pass
          next();
        }
      },
      meta: {
        title: 'Impressum',
        metaTags: [
          {
            name: 'description',
            content: 'Impressum'
          },
          {
            property: 'og:description',
            content: 'Impressum'
          }
        ]
      }
    },
    { 
      path: '/datenschutz',
      name: 'datenschutz',
      component: Datenschutz,
      beforeEnter: (to, from, next) => {
        if (from.name === "home" || from.name === "candidates" || from.name === "representatives" || from.name === "projects" || from.name === "themen" || from.name === "naniungo" || from.name === "about" || from.name === "vakanzen" || from.name === "impressum") {
          document.querySelector('.md-app-content').scrollIntoView();
          next();
        } 
        else {
          //pass
          next();
        }
      },
      meta: {
        title: 'Datenschutzbestimmungen',
        metaTags: [
          {
            name: 'description',
            content: 'datenschutzbestimmungen'
          },
          {
            property: 'og:description',
            content: 'datenschutzbestimmungen'
          }
        ]
      }
    },
    { 
      path: '/naniungo',
      name: 'naniungo',
      component: NaniungoLanding,
      beforeEnter: (to, from, next) => {
        if (from.name === "home" || from.name === "candidates" || from.name === "representatives" || from.name === "projects" || from.name === "themen" || from.name === "vakanzen") {
          document.querySelector('.md-app-content').scrollIntoView();
          next();
        } 
        else {
          //pass
          next();
        }
      },
      meta: {
        title: 'naniungo® Deutschland GmbH',
        metaTags: [
          {
            name: 'description',
            content: 'homepage'
          },
          {
            property: 'og:description',
            content: 'homepage'
          }
        ]
      }
    },
    { 
      path: '/themen',
      name: 'themen',
      component: Themen,
      beforeEnter: (to, from, next) => {
        if (from.name === "home" || from.name === "candidates" || from.name === "representatives" || from.name === "projects" || from.name === "about" || from.name === "naniungo" || from.name === "vakanzen") {
          document.querySelector('.md-app-content').scrollIntoView();
          next();
        } 
        else {
          //pass
          next();
        }
      },
      meta: {
        title: 'Themenschwerpunkte',
        metaTags: [
          {
            name: 'description',
            content: ' Themen rund um den Bereich Accounting, Controlling, Finance Functions, Marketing oder Sonderprojekte'
          },
          {
            property: 'og:description',
            content: ' Themen rund um den Bereich Accounting, Controlling, Finance Functions, Marketing oder Sonderprojekte'
          }
        ]
      }
    },
    { 
      path: '/karriere',
      name: 'karriere',
      component: Karriere,
      beforeEnter: (to, from, next) => {
        if (from.name === "home" || from.name === "candidates" || from.name === "representatives" || from.name === "projects" || from.name === "about" || from.name === "naniungo" || from.name === "changemanagement" || from.name === "prozessmanagement" || from.name === "themen" || from.name === "blog" ) {
          document.querySelector('.md-app-content').scrollIntoView();
          next();
        } 
        else {
          //pass
          next();
        }
      },
      meta: {
        title: 'Karriere',
        metaTags: [
          {
            name: 'description',
            content: 'Karriere durch naniungo. Gehen Sie Ihren nächsten Karriereschritt mit uns.'
          },
          {
            property: 'og:description',
            content: 'Karriere durch naniungo. Gehen Sie Ihren nächsten Karriereschritt mit uns.'
          }
        ]
      }
    },
    { 
      path: '/blog',
      name: 'blog',
      component: Blog,
      beforeEnter: (to, from, next) => {
        if (from.name === "home" || from.name === "candidates" || from.name === "representatives" || from.name === "projects" || from.name === "about" || from.name === "naniungo" || from.name === "changemanagement" || from.name === "prozessmanagement" || from.name === "themen" || from.name === "article" || from.name === "karriere") {
          document.querySelector('.md-app-content').scrollIntoView();
          next();
        } 
        else {
          //pass
          next();
        }
      },
      meta: {
        title: 'Blog',
        metaTags: [
          {
            name: 'description',
            content: 'Aktuelle Themen aus unterschiedlichen Bereichen'
          },
          {
            property: 'og:description',
            content: 'Aktuelle Themen aus unterschiedlichen Bereichen'
          }
        ]
      }
    },
    { 
      path: '/article/:id',
      name: 'article',
      component: Article,
      beforeEnter: (to, from, next) => {
        if (from.name === "home" || from.name === "candidates" || from.name === "representatives" || from.name === "projects" || from.name === "about" || from.name === "naniungo" || from.name === "changemanagement" || from.name === "prozessmanagement" || from.name === "themen" || from.name === "blog") {
          document.querySelector('.md-app-content').scrollIntoView();
          next();
        } 
        else {
          //pass
          next();
        }
      },
      meta: {
        title: 'Artikel',
        metaTags: [
          {
            name: 'description',
            content: 'Artikel'
          },
          {
            property: 'og:description',
            content: 'Artikel'
          }
        ]
      }
    },
    { 
      path: '/vakanzen/:id',
      name: 'vakanzen',
      component: Vakanzen,
      beforeEnter: (to, from, next) => {
        if (from.name === "home" || from.name === "candidates" || from.name === "representatives" || from.name === "projects" || from.name === "about" || from.name === "naniungo" || from.name === "changemanagement" || from.name === "prozessmanagement" || from.name === "themen" || from.name === "blog" || from.name === "publications") {
          document.querySelector('.md-app-content').scrollIntoView();
          next();
        } 
        else {
          //pass
          next();
        }
      },
      meta: {
        title: 'Vakanzen',
        metaTags: [
          {
            name: 'description',
            content: ''
          },
          {
            property: 'og:description',
            content: ''
          }
        ]
      }
    },
    { 
      path: '/consent/:id',
      name: 'consent',
      component: Consent,
      beforeEnter: (to, from, next) => {
        if (from.name === "home" || from.name === "candidates" || from.name === "representatives" || from.name === "projects" || from.name === "about" || from.name === "naniungo" || from.name === "changemanagement" || from.name === "prozessmanagement" || from.name === "themen" || from.name === "blog" || from.name === "publications") {
          document.querySelector('.md-app-content').scrollIntoView();
          next();
        } 
        else {
          //pass
          next();
        }
      },
      meta: {
        title: 'Consent',
        metaTags: [
          {
            name: 'description',
            content: ''
          },
          {
            property: 'og:description',
            content: ''
          }
        ]
      }
    }
  ]
})

router.beforeEach((to, from, next) => {
  // This goes through the matched routes from last to first, finding the closest route with a title.
  // eg. if we have /some/deep/nested/route and /some, /deep, and /nested have titles, nested's will be chosen.
  const nearestWithTitle = to.matched.slice().reverse().find(r => r.meta && r.meta.title);

  // Find the nearest route element with meta tags.
  const nearestWithMeta = to.matched.slice().reverse().find(r => r.meta && r.meta.metaTags);
  // const previousNearestWithMeta = from.matched.slice().reverse().find(r => r.meta && r.meta.metaTags);

  // If a route with a title was found, set the document (page) title to that value.
  if(nearestWithTitle) document.title = nearestWithTitle.meta.title;

  // Remove any stale meta tags from the document using the key attribute we set below.
  Array.from(document.querySelectorAll('[data-vue-router-controlled]')).map(el => el.parentNode.removeChild(el));

  // Skip rendering meta tags if there are none.
  if(!nearestWithMeta) return next();

  // Turn the meta tag definitions into actual elements in the head.
  nearestWithMeta.meta.metaTags.map(tagDef => {
    const tag = document.createElement('meta');

    Object.keys(tagDef).forEach(key => {
      tag.setAttribute(key, tagDef[key]);
    });

    // We use this to track which meta tags we create, so we don't interfere with other ones.
    tag.setAttribute('data-vue-router-controlled', '');

    return tag;
  })
  // Add the meta tags to the document head.
  .forEach(tag => document.head.appendChild(tag));

  next();
});

export default router;